import { pgTable } from "drizzle-orm/pg-core";

/**
 * Legacy wrapper around Drizzle `pgTable` for older auth table composition code.
 *
 * New projects should use generated `schema-auth.gen.ts` through `schema-auth.ts`
 * and fork that file directly when auth table customization is required.
 */
export const pgBaseTable: typeof pgTable = pgTable;
